import { getLiveChatCTAV2Template } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { readLiveChatCTAV2FromNode } from "@/assets/utilities/tinymce/helpers/liveChatCTAV2";
import { LIVE_CHAT_CTA_V2_EVENT_TYPES } from "@/constant";

const DIALOG_URL = "/live-chat-cta-v2-dialog";
const DIALOG_TITLE = "Livechat CTA #2";
const DIALOG_SIZE = { width: 600, height: 700 };

const dialogButtons = [
  { type: "cancel", name: "close", text: "Cancel" },
  { type: "custom", name: "submit", text: "Submit", primary: true },
];

const liveChatCTAV2Config = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const dialog = tinymce.activeEditor.windowManager.openUrl({
    title: DIALOG_TITLE,
    url: DIALOG_URL,
    buttons: dialogButtons,
    ...DIALOG_SIZE,
    onAction: instance => {
      if (!isValid || !currentData) {
        dialog.sendMessage({ type: LIVE_CHAT_CTA_V2_EVENT_TYPES.NEED_VALIDATION, data: true });

        return;
      }

      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, getLiveChatCTAV2Template(currentData));
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, instance, false);
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === LIVE_CHAT_CTA_V2_EVENT_TYPES.REQUEST_DATA) {
        dialog.sendMessage({ type: LIVE_CHAT_CTA_V2_EVENT_TYPES.SEND_DATA, data: {} });
      }

      if (message.mceAction === LIVE_CHAT_CTA_V2_EVENT_TYPES.UPDATE_LIVE_CHAT_CTA_V2_DATA) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === LIVE_CHAT_CTA_V2_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
  });
};

const editLiveChatCTAV2Config = (editor, node) => {
  const initialData = readLiveChatCTAV2FromNode(node);
  let currentData = initialData;
  let isValid = null;

  const dialog = editor.windowManager.openUrl({
    title: DIALOG_TITLE,
    url: DIALOG_URL,
    buttons: dialogButtons,
    ...DIALOG_SIZE,
    onAction: instance => {
      if (!isValid || !currentData) {
        dialog.sendMessage({ type: LIVE_CHAT_CTA_V2_EVENT_TYPES.NEED_VALIDATION, data: true });

        return;
      }

      node.outerHTML = getLiveChatCTAV2Template(currentData);
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === LIVE_CHAT_CTA_V2_EVENT_TYPES.REQUEST_DATA) {
        dialog.sendMessage({
          type: LIVE_CHAT_CTA_V2_EVENT_TYPES.SEND_DATA,
          data: initialData,
        });
      }

      if (message.mceAction === LIVE_CHAT_CTA_V2_EVENT_TYPES.UPDATE_LIVE_CHAT_CTA_V2_DATA) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === LIVE_CHAT_CTA_V2_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
  });
};

export { liveChatCTAV2Config, editLiveChatCTAV2Config };
